/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs } from 'framework/ui/BreadCrumbs';

const CandidatesBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  return <Breadcrumbs>{children}</Breadcrumbs>;
};

export default CandidatesBreadcrumbs;
